// Store-wide deterrent against casual saving of product media: no context menu or dragging on
// images and videos, and no download / picture-in-picture entries in native video controls.
// Screenshots and developer tools can still capture media; this only hides the easy options.
const MEDIA = 'img, video, picture, s-video';

function guardVideo(video) {
  video.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');
  video.setAttribute('disablepictureinpicture', '');
  video.setAttribute('disableremoteplayback', '');
}

document.addEventListener('contextmenu', (event) => {
  if (event.target instanceof Element && event.target.closest(MEDIA)) event.preventDefault();
}, { capture: true });

document.addEventListener('dragstart', (event) => {
  if (event.target instanceof Element && event.target.closest(MEDIA)) event.preventDefault();
}, { capture: true });

// Videos can be added later (gallery stage, quick view, infinite scroll), so cover those too.
document.querySelectorAll('video').forEach(guardVideo);
document.addEventListener('loadstart', (event) => {
  if (event.target instanceof HTMLVideoElement) guardVideo(event.target);
}, { capture: true });
new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node instanceof HTMLVideoElement) guardVideo(node);
      else node.querySelectorAll?.('video').forEach(guardVideo);
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });
